// A3 — THE COUNTRY MAP, MOVED HERE SO THE SERVER CAN READ IT TOO.
//
// It lived under `src/lib/` as a TypeScript module, and CLAUDE.md's own rule is that directory is
// CLIENT-ONLY: Node cannot import a `.ts` law, so the SERVER had no way to turn the `birthCountry`
// on a profile row into the ISO code the geocoder needs. A3 needs exactly that, and the
// alternative — a second copy of this table beside the geocode call — is two answers to one
// question on the one field whose history is already a bug (R28/R29).
//
// **THAT MODULE IS DELETED AND ITS TWO IMPORTERS POINT HERE** (`App.tsx`, `BirthFields.tsx`). A
// re-export was the first attempt and the gate refused it, correctly: R5 loads every `src/lib/`
// TypeScript module into a `data:` URL to RUN it, which works for exactly one class of module —
// one that imports NOTHING — so giving that file an import broke the instrument that guards the
// whole extraction. Deleting it is the move that keeps ONE declaration AND leaves no file able to
// violate that law.
//
// `countryCodeOf`'s bug history is kept verbatim with it, because it is the reason this function
// exists rather than a bare lookup: a stored row may hold the country NAME or its ISO CODE
// depending on which path wrote it, and this house has both live in the table today — measured
// during A3's pre-measure, where `lynyell22@gmail.com` carries `"US"` and every other affected
// member carries `"United States"`.

// Country name -> ISO 3166-1 alpha-2. geo_details only accepts a bare city name,
// so we filter its results by the chosen country's code client-side.
export const COUNTRY_CODES = {
  "United States": "US", "United Kingdom": "GB", Canada: "CA", Australia: "AU",
  Ireland: "IE", "New Zealand": "NZ", Nigeria: "NG", Ghana: "GH", Kenya: "KE",
  "South Africa": "ZA", Ethiopia: "ET", Egypt: "EG", Morocco: "MA", Senegal: "SN",
  Cameroon: "CM", Uganda: "UG", Tanzania: "TZ", Zimbabwe: "ZW", Zambia: "ZM",
  "Ivory Coast": "CI", "Sierra Leone": "SL", Liberia: "LR", Somalia: "SO",
  Jamaica: "JM", Haiti: "HT", "Trinidad and Tobago": "TT", Barbados: "BB",
  Bahamas: "BS", Cuba: "CU", "Dominican Republic": "DO", "Puerto Rico": "PR",
  Brazil: "BR", Mexico: "MX", Argentina: "AR", Colombia: "CO", Peru: "PE",
  Chile: "CL", Venezuela: "VE", Guyana: "GY", Panama: "PA",
  France: "FR", Germany: "DE", Spain: "ES", Italy: "IT", Portugal: "PT",
  Netherlands: "NL", Belgium: "BE", Switzerland: "CH", Austria: "AT",
  Sweden: "SE", Norway: "NO", Denmark: "DK", Finland: "FI", Poland: "PL",
  Greece: "GR", Russia: "RU", Ukraine: "UA", Turkey: "TR",
  India: "IN", Pakistan: "PK", Bangladesh: "BD", "Sri Lanka": "LK", Nepal: "NP",
  China: "CN", Japan: "JP", "South Korea": "KR", Vietnam: "VN", Thailand: "TH",
  Philippines: "PH", Indonesia: "ID", Malaysia: "MY", Singapore: "SG",
  Israel: "IL", "Saudi Arabia": "SA", "United Arab Emirates": "AE", Iran: "IR",
  Iraq: "IQ", Lebanon: "LB", Jordan: "JO",
};

export const COUNTRY_NAMES = Object.keys(COUNTRY_CODES);

// ISO alpha-2 -> full country name, so places worldwide read as "City, Country"
// rather than "City, GB". Falls back to the raw code for anything unmapped.
export const COUNTRY_NAMES_BY_CODE = Object.fromEntries(
  Object.entries(COUNTRY_CODES).map(([name, code]) => [code, name]),
);

// I2: a stored row may hold the country NAME ("United States") or its ISO code ("US") — both are
// written by paths that predate each other. COUNTRY_CODES is keyed by NAME only, so a row holding
// a code fell through to "" and re-searched the entire world for the city. That is the empty
// countryCode the 24th session captured on a saved person: {"place":"Denver","countryCode":""}.
export function countryCodeOf(value) {
  const raw = (value || "").trim();
  if (!raw) return "";
  if (COUNTRY_CODES[raw]) return COUNTRY_CODES[raw];
  const upper = raw.toUpperCase();
  return COUNTRY_NAMES_BY_CODE[upper] ? upper : "";
}
